export default {
    up: 1500,
    right: 1501,
    down: 1502,
    left: 1503,

    zoom_in: 1510,
    zoom_out: 1511,
};